
<div class="">
   
        <div class="">
           
            <div class="">
                <div class="formStyle">
                    <mat-card-content class="addEditPageWrapper practice_form_style form_title_style">
                        <!-- <ng-container *ngIf="addFormLoader">
                            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                        </ng-container> -->
                        <div class="AddEditBlog taxonomies_formstyle">
                            <div class="addEditForm">
                                <lib-showform [formdata]="userformdata" 
                                
                                    (onFormFieldChange)="listenFormFieldChange($event)">
                                </lib-showform>

                                <!-- <ng-container *ngIf="addFormLoader">
                                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                                </ng-container>
                                <mat-progress-bar *ngIf="loader" mode="indeterminate"></mat-progress-bar> -->
                            </div>
                            <mat-progress-bar *ngIf="loader" mode="indeterminate"></mat-progress-bar>
                        </div>

                    </mat-card-content>

                </div>
            </div>
        </div>
   
</div>

    <span mat-button mat-dialog-close class="close-btn-modal material-icons">close</span>
